import React from "react";

const aboutRoutes = [
    {
        path: "/about",
        element: "about",
    }
];

export default aboutRoutes;